var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"log-list-value"},[_c('pre',{class:{truncate: _vm.truncateBigTexts}},[_vm._v("  "+_vm._s(_vm.content)+"\n  ")]),_c('v-divider')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }